import { Select } from 'alurkerja-ui';

interface FilterOption {
  label: string;
  value: string;
}

interface FilterSelectProps {
  label?: string;
  placeholder?: string;
  options: FilterOption[];
  value: string;
  onChange: (value: string) => void;
  showAllOption?: boolean;
}

export default function FilterSelect({
  label,
  placeholder,
  options,
  value,
  onChange,
  showAllOption = true,
}: FilterSelectProps) {
  const currentValue = value ? options.find(opt => opt.value === value) || null : null;

  const displayPlaceholder = placeholder || (label ? `Filter by ${label}` : 'Select option');

  const selectOptions = showAllOption && label ? [{ label: `All ${label}`, value: '' }, ...options] : options;

  return (
    <Select
      size="sm"
      placeholder={displayPlaceholder}
      options={selectOptions}
      value={currentValue}
      onChange={(selected: any) => onChange(selected?.value || '')}
      className="text-sm"
    />
  );
}
